// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d186faca","455":"24dfcd9b","977":"b4589e1c"}[chunkId] + ".chunk.js";
};